import { type State } from 'types/api'
import { create } from 'zustand'

interface SetState {
  passedState: State | undefined
  setPassedState: (passedStateId: State | undefined) => void
}

export const useSetState = create<SetState>((set) => ({
  passedState: undefined,
  setPassedState: (passedState: any) => {
    set({ passedState })
  },
}))
